// Lib
import { FilterItem } from 'features/Dealers/Performance/Filter/state/types';
import { Action } from 'redux';

// Constants
import * as ACTIONS from './actionTypes';

export interface ActionGetClientAPI extends Action {
}

export const getFiltersAPI = (): ActionGetClientAPI => ({
    type: ACTIONS.GET_FILTERS_API_REQUEST,
});

export const getSearchAPI = (): ActionGetClientAPI => ({
    type: ACTIONS.GET_FILTERS_API_REQUEST,
});

export interface ActionGetFiltersApiSuccess extends Action {
    filtersItems: FilterItem[]
}

export const getFiltersAPISuccess = (filtersItems: FilterItem[]): ActionGetFiltersApiSuccess => ({
    type: ACTIONS.GET_FILTERS_API_SUCCESS,
    filtersItems
});

export const getFiltersAPIError = (error: any): Action & { error: any } => ({
    type: ACTIONS.GET_FILTERS_API_ERROR,
    error
});